import lodash from 'lodash';

import {
  PollData_Design_PollDesign_Background_Type,
  PollData_Layout_PollLayout_Type,
  PollData_Poll_Settings_Permissions_VoteRole,
} from './../../../ricos-schema/legacy/wix/rich_content/v1';
import { unreachable } from './../../../editor-common';

import {
  BACKGROUND_PRESETS,
  DEFAULT_RICOS_COMPONENT_DATA,
  OPTION_IMAGES_POOL,
  POLL_IMAGES_POOL,
} from '../../defaults';
import { getRandomValue } from '../../helpers';
import type { PollPluginEditorConfig } from '../../types';

export const PRESET_TYPE = {
  LIST: 'list',
  LIST_WITH_IMAGE: 'listWithImage',
  GRID: 'grid',
} as const;

export type PresetType = (typeof PRESET_TYPE)[keyof typeof PRESET_TYPE];

export const createInitialPollData = (config: PollPluginEditorConfig, presetType: PresetType) => {
  const initialData = lodash.merge({}, DEFAULT_RICOS_COMPONENT_DATA, {
    poll: {
      settings: {
        permissions: { vote: config?.vote || PollData_Poll_Settings_Permissions_VoteRole.ALL },
      },
    },
  });

  const layoutData = (() => {
    switch (presetType) {
      case PRESET_TYPE.LIST: {
        return {
          poll: {
            type: PollData_Layout_PollLayout_Type.LIST,
            enableImage: false,
          },
          options: {
            enableImage: false,
          },
        };
      }
      case PRESET_TYPE.LIST_WITH_IMAGE: {
        return {
          poll: {
            type: PollData_Layout_PollLayout_Type.LIST,
            enableImage: true,
          },
          options: {
            enableImage: false,
          },
        };
      }
      case PRESET_TYPE.GRID: {
        return {
          poll: {
            type: PollData_Layout_PollLayout_Type.GRID,
            enableImage: false,
          },
          options: {
            enableImage: true,
          },
        };
      }
      default:
        unreachable(presetType);
        throw new Error('Unknown preset type', presetType);
    }
  })();

  return lodash.merge({}, initialData, {
    poll: {
      image: { src: { url: getRandomValue(POLL_IMAGES_POOL) } },
      options: [
        {
          title: '',
          image: { src: { url: getRandomValue(OPTION_IMAGES_POOL) } },
        },
        {
          title: '',
          image: { src: { url: getRandomValue(OPTION_IMAGES_POOL) } },
        },
      ],
    },
    layout: layoutData,
    design: {
      poll: {
        background: {
          type: PollData_Design_PollDesign_Background_Type.IMAGE,
          image: {
            src: {
              url: getRandomValue(
                BACKGROUND_PRESETS[PollData_Design_PollDesign_Background_Type.IMAGE]
              ),
            },
          },
        },
      },
      borderRadius: 0,
      options: { borderRadius: 0 },
    },
  });
};
